module.exports = __webpack_public_path__ + "img/gather sleeve ruffle.aece121b.png";